import { useState, useEffect, useCallback } from "react";
import { rcRepository } from "../repositories/rc.repository";
import { shouldMakeAPICall } from "../utils/network";

export const useOfflineRc = (authToken, buyerToken) => {
  const [rcs, setRCs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRCs = useCallback(async () => {
    setLoading(true);

    // Load cache first
    const cached = await rcRepository.getRCsFromCache();
    setRCs(cached);

    // Sync if allowed
    if (shouldMakeAPICall(authToken, buyerToken)) {
      const synced = await rcRepository.syncRCsFromAPI(
        authToken,
        buyerToken
      );
      setRCs(synced);
    }

    setLoading(false);
  }, [authToken, buyerToken]);

  useEffect(() => {
    loadRCs();
  }, [loadRCs]);

  return { rcs, loading, refetch: loadRCs };
};
